import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { AppDispatch, RootState } from "../app/store";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import BoxesPage from "./BoxesPage";
import BoxDetails, { GifBoxDetails } from "./BoxDetails";
import AllBoxesPage, { GiftCategoryBoxesPage } from "./AllBoxes";
import localization from "../services/localization";
import GiftsPage from "./GiftsPage";
import ChaosPage from "./ChaosPage";
import ProfileDetailsLayoutComponent from "./ProfileDetailsLayoutComponent";
import { handlePageSelection } from "../features/pageSlice";
import SupportPage from "./SupportPage";
import DocumentLoader from "./DocumentLoader";
import HowItWorksPage from "./HowItWorks";
import VipPage from "./VipPage";
import ReceivedGiftsComponent from "./ReceivedGiftsComponent";
import {
  Platform,
  PromotionInfoVipMysteryBox,
  PromotionsComponent,
} from "keycloakauthmodule";
import Footer from "./Footer";
import OmegaJamAcademyPage from "./OmegaJamAcademyPage";

const ContentWrapper = styled.div`
  flex: 1;
  padding: 20px;
  background-color: #000c0d;
  color: #755c5c;
  overflow-y: auto;
`;

const ComingSoon = styled.div`
  font-family: Verdana;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
  align-items: center;
`;

const ContentArea: React.FC = () => {
  const selectedPage = useSelector(
    (state: RootState) => state.page.selectedPage
  );
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      const contentWrapper =
        document.querySelector("div[role='main']") ||
        document.querySelector("main") ||
        document.querySelector("#content");

      if (contentWrapper) {
        (contentWrapper as HTMLElement).scrollTo({ top: 0, behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 50);
  }, [location.pathname]);

  useEffect(() => {
    const TOKEN = localStorage.getItem("token");
    const path = location.pathname;

    if (
      !TOKEN &&
      (
        path.startsWith("/chaos") ||
        path.startsWith("/profile") ||
        path.startsWith("/account") ||
        path.startsWith("/transactions") ||
        path.startsWith("/history") ||
        path.startsWith("/omegajam-academy")
      )
    ) {
      navigate("/", { replace: true });
      return;
    }

    if (path === "/") {
      dispatch(handlePageSelection("home"));
      return;
    }

    if (path.startsWith("/reset-password")) {
      dispatch(handlePageSelection("reset-password"));
      return;
    }

    if (path.startsWith("/activate-account")) {
      dispatch(handlePageSelection("activate-account"));
      return;
    }

    if (
      !TOKEN &&
      (
        path.startsWith("/chaos") ||
        path.startsWith("/profile") ||
        path.startsWith("/omegajam-academy")
      )
    ) {
      navigate("/");
      return;
    }

    if (selectedPage === "" || selectedPage === "boxes") {
      if (path.startsWith("/gifts")) {
        dispatch(handlePageSelection("gifts"));
      } else if (path.startsWith("/chaos")) {
        dispatch(handlePageSelection("chaos"));
      } else if (path.startsWith("/boxes")) {
        dispatch(handlePageSelection("boxes"));
      } else if (path.startsWith("/profile")) {
        dispatch(handlePageSelection("profile"));
      } else if (path.startsWith("/account")) {
        dispatch(handlePageSelection("account"));
      } else if (path.startsWith("/transactions")) {
        dispatch(handlePageSelection("transactions"));
      } else if (path.startsWith("/history")) {
        dispatch(handlePageSelection("history"));
      } else if (path.startsWith("/cookie-policy")) {
        dispatch(handlePageSelection("cookie-policy"));
      } else if (path.startsWith("/privacy-policy")) {
        dispatch(handlePageSelection("privacy-policy"));
      } else if (path.startsWith("/terms-of-service")) {
        dispatch(handlePageSelection("terms-of-service"));
      } else if (path.startsWith("/how-it-works")) {
        dispatch(handlePageSelection("how-it-works"));
      } else if (path.startsWith("/support")) {
        dispatch(handlePageSelection("support"));
      } else if (path.startsWith("/promotions")) {
        dispatch(handlePageSelection("promotions"));
      } else if (path.startsWith("/all_promotions")) {
        dispatch(handlePageSelection("all_promotions"));
      } else if (path.startsWith("/omegajam-academy")) {
        dispatch(handlePageSelection("omegajam-academy"));
      } else {
        dispatch(handlePageSelection("home"));
      }
    }
  }, [selectedPage, location.pathname, dispatch, navigate]);

  return (
    <ContentWrapper id="content">
      {(selectedPage === "boxes" || selectedPage === "home") && (
        <Routes>
          <Route path="/" element={<BoxesPage />} />
          <Route path="/boxes/" element={<AllBoxesPage />} />
          <Route path="/boxes/:boxId" element={<BoxDetails />} />
        </Routes>
      )}

      {selectedPage === "chaos" && (
        <Routes>
          <Route path="/chaos/" element={<ChaosPage />} />
          <Route path="/chaos/:boxId" element={<BoxDetails />} />
        </Routes>
      )}

      {selectedPage === "gifts" && (
        <Routes>
          <Route path="/gifts/" element={<GiftsPage />} />
          <Route path="/gifts/received/" element={<ReceivedGiftsComponent />} />
          <Route path="/gifts/received/:boxId" element={<BoxDetails />} />
          <Route path="/gifts/:categoryId" element={<GiftCategoryBoxesPage />} />
          <Route path="/gifts/:categoryId/:boxId" element={<GifBoxDetails />} />
        </Routes>
      )}

      {selectedPage === "cookie-policy" && (
        <Routes>
          <Route
            path="/cookie-policy"
            element={
              <DocumentLoader
                title="Cookie Policy"
                docxPath="/assets/docs/cookie_policy.docx"
              />
            }
          />
        </Routes>
      )}

      {selectedPage === "privacy-policy" && (
        <Routes>
          <Route
            path="/privacy-policy"
            element={
              <DocumentLoader
                title="Privacy Policy"
                docxPath="/assets/docs/privacy_policy.docx"
              />
            }
          />
        </Routes>
      )}

      {selectedPage === "terms-of-service" && (
        <Routes>
          <Route
            path="/terms-of-service"
            element={
              <DocumentLoader
                title="Term of service"
                docxPath="/assets/docs/user_agreement.docx"
              />
            }
          />
        </Routes>
      )}

      {selectedPage === "how-it-works" && (
        <Routes>
          <Route path="/how-it-works" element={<HowItWorksPage />} />
        </Routes>
      )}

      {selectedPage === "support" && (
        <Routes>
          <Route path="/support" element={<SupportPage />} />
        </Routes>
      )}

      {selectedPage === "affiliates" && (
        <ComingSoon>{localization.affiliates_content_coming_soon}</ComingSoon>
      )}

      {selectedPage === "vips" && (
        <Routes>
          <Route path="/vips/" element={<VipPage />} />
          <Route path="/vips/:boxId" element={<BoxDetails />} />
        </Routes>
      )}

      {selectedPage === "profile" && <ProfileDetailsLayoutComponent />}
      {selectedPage === "account" && <ProfileDetailsLayoutComponent />}
      {selectedPage === "transactions" && <ProfileDetailsLayoutComponent />}
      {selectedPage === "history" && <ProfileDetailsLayoutComponent />}

      {selectedPage === "omegajam-academy" && (
        <Routes>
          <Route path="/omegajam-academy" element={<OmegaJamAcademyPage />} />
        </Routes>
      )}

      {selectedPage === "promotions" && (
        <Routes>
          <Route
            path="/promotions/vip-mystery-box"
            element={
              <>
                <PromotionInfoVipMysteryBox />
                <Footer />
              </>
            }
          />
        </Routes>
      )}

      {selectedPage === "all_promotions" && (
        <Routes>
          <Route
            path="/all_promotions"
            element={
              <>
                <PromotionsComponent platform={Platform.BOXCHAOS}>
                  <Footer />
                </PromotionsComponent>
              </>
            }
          />
        </Routes>
      )}
    </ContentWrapper>
  );
};

export default ContentArea;